// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_8719dd88","outerContainer":"_495a9640","secondaryToolbar":"efac136e","doorHangerRight":"fe9506fc","toolbarContainer":"_7c743c5c","toolbarViewerMiddle":"e50d8656","progressBar":"_7cba0d6b","back-to-application":"_22502297","wrapper":"_09a9d39b","item":"_824eda14","redText":"bdd713e5","left":"_22cb2785","right":"_661b6f50"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PatientHealthboard/PatientPortal/LabTestHistoryModal/LabTestHistoryList/index.styl
// module id = 5061
// module chunks = 39